import React from 'react';
import type { IUrlLinkItem } from '../../../../ui';
import { FooterLink } from '../../../../ui/new-components/FooterLink';
import { getLinkPropsForUrl } from '../../components/link/utils/getLinkPropsForUrl';
import { cn } from '../../utils/cn';

export interface IFooterLinkListProps {
	isOpen: boolean;
	links: IUrlLinkItem[];
	id?: string;
}

export const FooterLinkList = ({ links, isOpen, id }: IFooterLinkListProps) => (
	<ul
		id={id}
		className={cn(
			'list-none p-0 m-0',
			'[&>li]:mb-2.5 [&>li]:pl-0 [&>li:last-of-type]:mb-0',
			'max-mobile-xl:pt-3 max-mobile-xl:text-base',
			!isOpen && 'max-mobile-xl:hidden',
		)}
	>
		{links.map((link) => (
			<li key={link.key}>
				<FooterLink {...getLinkPropsForUrl(link.url)}>{link.title}</FooterLink>
			</li>
		))}
	</ul>
);
